export default __webpack_public_path__ + "static/Gmail3-a5175d87dad5bea8862556828edee39e.png";